import { render, staticRenderFns } from "./CoursewareImageMapBlock.vue?vue&type=template&id=a67daf50&scoped=true&"
import script from "./CoursewareImageMapBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareImageMapBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareImageMapBlock.vue?vue&type=style&index=0&id=a67daf50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67daf50",
  null
  
)

export default component.exports